import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { localizer } from 'utils/localizer';
import { CustomForm, CustomInput, CustomButton } from 'modules/form';
import SHA512 from 'crypto-js/sha512';
import { login } from './LoginActions';

//import './LoginForm.css'

class LoginForm extends CustomForm {
    constructor(props) {
        super(props);
        //this.state.loginState = this.props.loginState;
    }
    onSubmitHandler = () => {
        if (this.isFormValid()) {
            const form = this.serializeForm();
            form.password = SHA512(form.password).toString();

            login(form);
        }
    };
    render() {
        console.log('Form State: ', this.state);
        return (
            <div className="login-form">
                <p>
                    If you are an existing user, please enter your Email and
                    Password below. If you are a new user, please click on "New
                    User Sign Up".
                </p>
                <CustomInput
                    name="email"
                    type="email"
                    label="Email Address"
                    form={this}
                />
                <CustomInput
                    type="password"
                    label={localizer.LOGIN_LBL_PASSWORD}
                    name="password"
                    required
                    form={this}
                />
                <CustomButton
                    type="primary-button"
                    action={this.onSubmitHandler}
                    label="Existing User Sign In"
                    loading={this.props.loginState.loading}
                />
                <div class="link">
                    <Link to="signup">New User Sign Up</Link>
                </div>
            </div>
        );
    }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/login/LoginForm.jsx